var _path, _g, _g2, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultipleAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6519 14.6086V13.3913C17.6519 12.0324 17.9196 10.6868 18.4396 9.43134C18.9596 8.17588 19.7218 7.03515 20.6827 6.07427C21.6436 5.11338 22.7843 4.35117 24.0398 3.83114C25.2953 3.31111 26.6409 3.04346 27.9997 3.04346C29.3586 3.04346 30.7042 3.31111 31.9597 3.83114C33.2151 4.35117 34.3559 5.11338 35.3168 6.07427C36.2776 7.03515 37.0399 8.17588 37.5599 9.43134C38.0799 10.6868 38.3476 12.0324 38.3476 13.3913V14.6086H43.9774C44.5828 14.6086 45.1634 14.8651 45.5915 15.3217C46.0195 15.7783 46.26 16.3976 46.26 17.0434V48.6956C46.26 49.3413 46.0195 49.9606 45.5915 50.4172C45.1634 50.8738 44.5828 51.1303 43.9774 51.1303H12.0209C11.4155 51.1303 10.8349 50.8738 10.4068 50.4172C9.97877 49.9606 9.73828 49.3413 9.73828 48.6956V17.0434C9.73828 16.3976 9.97877 15.7783 10.4068 15.3217C10.8349 14.8651 11.4155 14.6086 12.0209 14.6086H17.6519ZM25.4374 7.20531C26.2498 6.86882 27.1205 6.69563 27.9997 6.69563C28.879 6.69563 29.7497 6.86882 30.5621 7.20531C31.3744 7.5418 32.1125 8.03499 32.7343 8.65674C33.356 9.27849 33.8492 10.0166 34.1857 10.829C34.5222 11.6413 34.6954 12.512 34.6954 13.3913V14.6086H21.3041V13.3913C21.3041 12.512 21.4773 11.6413 21.8138 10.829C22.1503 10.0166 22.6435 9.27849 23.2652 8.65674C23.887 8.03499 24.6251 7.5418 25.4374 7.20531Z",
    fill: "url(#paint0_linear_13878_11627)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_13878_11627)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5658,
    cy: 43.2174,
    r: 10.7826,
    stroke: "#143239",
    strokeOpacity: 0.6,
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_13878_11627)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5659,
    cy: 43.2175,
    r: 10.9565,
    fill: "#EDF0F5",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5659,
    cy: 43.2175,
    r: 9.95652,
    stroke: "white",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5662 37.739C40.1713 37.739 40.6618 38.2296 40.6618 38.8347V42.1216H43.9488C44.5539 42.1216 45.0444 42.6122 45.0444 43.2173C45.0444 43.8224 44.5539 44.3129 43.9488 44.3129H40.6618V47.5999C40.6618 48.205 40.1713 48.6955 39.5662 48.6955C38.961 48.6955 38.4705 48.205 38.4705 47.5999V44.3129H35.1835C34.5784 44.3129 34.0879 43.8224 34.0879 43.2173C34.0879 42.6122 34.5784 42.1216 35.1835 42.1216H38.4705V38.8347C38.4705 38.2296 38.961 37.739 39.5662 37.739Z",
    fill: "url(#paint1_linear_13878_11627)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_13878_11627",
    x: 15.8308,
    y: 19.4824,
    width: 47.4692,
    height: 47.4699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.47619
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13878_11627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13878_11627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_13878_11627",
    x: 17.657,
    y: 21.3086,
    width: 43.8169,
    height: 43.8178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.47619
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13878_11627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13878_11627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13878_11627",
    x1: 8.59697,
    y1: 52.048,
    x2: 104.952,
    y2: -5.33483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13447,
    stopColor: "#38B2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677447,
    stopColor: "#F7E74E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13878_11627",
    x1: 36.8449,
    y1: 39.7398,
    x2: 49.8747,
    y2: 47.2376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4DE5F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleAccounts);
export default __webpack_public_path__ + "static/media/multiple-accounts.973c0cc0b7df87609386177ac24ee88f.svg";
export { ForwardRef as ReactComponent };